import type { PromoParticipationRole } from "./promo-form-config";

export function hasSecondSpeaker(props: { speaker2Name?: string }): boolean {
  return Boolean(props.speaker2Name?.trim());
}

export function canHaveSecondSpeaker(role: PromoParticipationRole): boolean {
  return role !== "coordenador";
}

export function usesSharedSpeakerPhoto(props: {
  speaker2Name?: string;
  sharedPhoto?: boolean;
}): boolean {
  return hasSecondSpeaker(props) && props.sharedPhoto === true;
}

export function normalizeSharedPhotoFields(input: {
  speaker2Name?: string;
  sharedPhoto?: boolean;
  photoUrl2?: string;
  photoOffsetX2?: number;
  photoOffsetY2?: number;
  photoScale2?: number;
}): {
  sharedPhoto: boolean;
  photoUrl2: string;
  photoOffsetX2: number;
  photoOffsetY2: number;
  photoScale2: number;
} {
  const sharedPhoto = usesSharedSpeakerPhoto(input);
  if (!sharedPhoto) {
    return {
      sharedPhoto: false,
      photoUrl2: input.photoUrl2 ?? "",
      photoOffsetX2: input.photoOffsetX2 ?? 0,
      photoOffsetY2: input.photoOffsetY2 ?? 0,
      photoScale2: input.photoScale2 ?? 1,
    };
  }

  return {
    sharedPhoto: true,
    photoUrl2: "",
    photoOffsetX2: 0,
    photoOffsetY2: 0,
    photoScale2: 1,
  };
}
